import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { SiPostman, SiVisualstudiocode, SiDocker, SiGithubactions, SiFigma, SiAndroidstudio } from "react-icons/si";
import { FaGitAlt, FaGithub, } from "react-icons/fa";
import Zoom from "react-reveal/Zoom";

export default function Toolkit() {
  return (
    <div>
      
      <Zoom left cascade>
        <h1 className="mt-4"><span style={{color:"#b061df"}}>Tools</span> I Use</h1>
      </Zoom>
      <Container className="mt-4 ">
      <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
        <Col xs={5} md={2} className="tech-icons">
          <SiVisualstudiocode />
        </Col>
        <Col xs={5} md={2} className="tech-icons">
        <SiAndroidstudio />
        </Col>
        <Col xs={5} md={2} className="tech-icons">
        <SiPostman />
        </Col>
        <Col xs={5} md={2} className="tech-icons">
        <SiDocker />
        </Col>
        <Col xs={5} md={2} className="tech-icons">
        <SiGithubactions />
        </Col>
        <Col xs={5} md={2} className="tech-icons">
        <SiFigma />
        </Col>
        <Col xs={5} md={2} className="tech-icons">
        <FaGitAlt />
        </Col>
        <Col xs={5} md={2} className="tech-icons">
        <FaGithub />
        </Col>
      </Row>
    </Container>
    </div>
  );
}
